import { SUPABASE_URL, getDbHeaders } from "./client";

export async function dbSubmitFeedback(payload) {
  const res = await fetch(SUPABASE_URL + "/rest/v1/feedback", {
    method: "POST",
    headers: await getDbHeaders({ "Prefer": "return=minimal" }),
    body: JSON.stringify(payload),
  });
  return res.ok;
}

export async function dbLoadFeedback() {
  const res = await fetch(SUPABASE_URL + "/rest/v1/feedback?order=created_at.desc&select=*", {
    headers: await getDbHeaders(),
  });
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function dbMarkFeedbackResolved(id, resolved) {
  await fetch(SUPABASE_URL + "/rest/v1/feedback?id=eq." + id, {
    method: "PATCH",
    headers: await getDbHeaders({ "Prefer": "return=minimal" }),
    body: JSON.stringify({ resolved }),
  });
}

export async function dbDeleteFeedback(id) {
  await fetch(SUPABASE_URL + "/rest/v1/feedback?id=eq." + id, {
    method: "DELETE",
    headers: await getDbHeaders(),
  });
}
